import ClickLogger from '@/components/common/ClickLogger';
import Link from 'next/link';
import useMedicalCategoryDisplayViewModel from '../hooks/useMedicalCategoryDisplayViewModel';
import { CATEGORY_ITEM_STYLES, MEDICAL_CATEGORY_CONFIG } from '../lib/constants';
import CategoryGrid from './CategoryGrid';
import CategoryItem from './CategoryItem';

const MedicalCategoryGrid = () => {
  const viewModel = useMedicalCategoryDisplayViewModel(MEDICAL_CATEGORY_CONFIG.DEFAULT_DISPLAY_SIZE);

  return (
    <CategoryGrid isLoading={viewModel.isLoading}>
      {viewModel.medicalCategories.map((category) => (
        <CategoryItem
          key={category.id}
          category={category}
          onClickCategory={() => viewModel.onClickCategory(category)}
        />
      ))}
      <ClickLogger params={{ eventName: 'category_item_click', payload: { categoryId: viewModel.moreCategory.id } }}>
        <Link href={viewModel.moreCategoryPath}>
          <a className='flex min-h-[88px] cursor-pointer flex-col items-center justify-center gap-[12px] rounded-[8px] p-[8px] sm:min-h-[108px]'>
            <div className={CATEGORY_ITEM_STYLES.ICON_CONTAINER}>
              <img
                src={viewModel.moreCategory.iconUrl ?? ''}
                alt={viewModel.moreCategory.name ?? ''}
                className={CATEGORY_ITEM_STYLES.ICON}
              />
            </div>
            <span className={CATEGORY_ITEM_STYLES.NAME}>{viewModel.moreCategory.name ?? ''}</span>
          </a>
        </Link>
      </ClickLogger>
    </CategoryGrid>
  );
};

export default MedicalCategoryGrid;
